var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { class: { "app-login": !_vm.auth } },
    [
      _vm.auth && _vm.sidenav ? _c("app-sidenav") : _vm._e(),
      _vm._v(" "),
      _vm.auth ? _c("app-navbar") : _vm._e(),
      _vm._v(" "),
      _vm.main
        ? _c("v-content", [
            _c(
              "div",
              { staticClass: "main pt-3" },
              [
                _c(
                  "transition",
                  { attrs: { name: _vm.transitionName, mode: "out-in" } },
                  [_c("router-view")],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("app-notification"),
      _vm._v(" "),
      _c("app-footer"),
      _vm._v(" "),
      _c("app-messages"),
      _vm._v(" "),
      _c("app-alert"),
      _vm._v(" "),
      _c("app-confirm"),
      _vm._v(" "),
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c("app-loading")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 